import { render, staticRenderFns } from "./UserBox.vue?vue&type=template&id=259fab93&scoped=true"
import script from "./UserBox.vue?vue&type=script&lang=js"
export * from "./UserBox.vue?vue&type=script&lang=js"
import style0 from "./UserBox.vue?vue&type=style&index=0&id=259fab93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259fab93",
  null
  
)

export default component.exports